/* "Showing results for '...'" heading on /all-products when the header
 * search form (nav/search.html) landed here via ?search=<query>. Presence-
 * detected, same page gating as catalog_search_enter.js (which already
 * owns turning that param into an actual filtered query) - this file only
 * adds the visual line, no filtering logic of its own.
 */

frappe.ready(function () {
	var listing = document.getElementById('product-listing');
	if (!listing) return; // not this page

	var query = new URLSearchParams(window.location.search).get('search');
	if (!query) return; // plain /all-products, nothing to announce

	var heading = document.createElement('p');
	heading.className = 'rfhq-search-results-heading';
	heading.innerHTML = __('Showing results for') + ' “<strong></strong>”';
	heading.querySelector('strong').textContent = query;

	// Above the .row (filters + listing), not inside #product-listing - core's
	// ProductView replaces that element's entire innerHTML on every filter/
	// search re-render (that's the whole point of catalog_search_enter.js's
	// patch), which would silently wipe a heading inserted as its child the
	// moment the listing finished its own async fetch.
	var row = listing.closest('.row') || listing.parentElement;
	row.parentElement.insertBefore(heading, row);
});
